"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query EditorialCategoryOrPage(\n    $pageId: ID!\n    $landingPageId: ID\n    $includeThemeItems: Boolean! = false\n    $includeRoot: Boolean! = true\n  ) {\n    application {\n      ...EditorialArticlePage\n      ...EditorialCategoryPage\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialCategoryOrPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _editorialArticlePageFragment = require("./editorialArticlePageFragment");
var _editorialCategoryPageFragment = require("./editorialCategoryPageFragment");
const editorialCategoryOrPageQuery = exports.editorialCategoryOrPageQuery = (0, _fetching.gql)(_templateObject(), _editorialCategoryPageFragment.editorialCategoryPageFragment, _editorialArticlePageFragment.editorialArticlePageFragment);
